import { html, LitElement, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import styles from './TopBar.scss?inline';
import '../ActionMenu/ActionMenu'
import { ActionMenuItem } from "../ActionMenu/ActionMenu";

export interface AppBarAction {
    ID: string;
    Icon: string;
    Label: string;
    IsPrimary?: boolean;
    onClick: () => void;
}

@customElement('app-top-bar')
export class TopBar extends LitElement {
    static styles = [unsafeCSS(styles)];
    @property({ type: Array, attribute: false }) k_options: ActionMenuItem[] = [];
    @property({ type: String, attribute: false }) k_title: string = '';
    @property({ type: String, attribute: false }) k_subtitle: string = '';
    @property({ type: Boolean, reflect: true }) k_showLeadingContent: boolean = true;

    render() {
        return html`
            ${this.k_showLeadingContent ? html`<div class='start'><slot name='start'></slot></div>` : null}
            <div class='title-container'>
                <span class='main-title'>${this.k_title}</span>
                ${!this.k_subtitle ? null : html`<span class='subtitle'>${this.k_subtitle}</span>`}
            </div>
            <div class='end'>
                <app-action-menu
                    .k_actions=${this.k_options}
                    .k_iconSize=${'small'}
                >
                </app-action-menu>
            </div>
        `
    }
}